import mock from 'utils/mock';

mock.onGet('/api/tranfer').reply(200, {
  total: [
    { name: 'Total Transfer', amount: '650,000.00' },
    { name: 'Total Fee', amount: '6,500.00' }
  ],
  data: [
    {
      receiptName: 'Jack',
      receiptId: '5dc234f890',
      amount: '5,000.00',
      account: 'SCB',
      paid: '2020-01-11T18:00:00.549Z',
      status: 'Transferred'
    },
    {
      receiptName: 'Tony',
      receiptId: '5dc234ff90',
      amount: '15,000.00',
      account: 'SCB',
      paid: '2020-01-11T17:05:00.549Z',
      status: 'Transferred'
    },
    {
      receiptName: 'Tom',
      receiptId: '5dc234f590',
      amount: '2,000.00',
      account: 'BBL',
      paid: '2020-01-11T16:10:00.549Z',
      status: 'Incomplete'
    },
    {
      receiptName: 'Chris',
      receiptId: '5dc234f990',
      amount: '800.00',
      account: 'BBL',
      paid: '2020-01-11T15:15:00.549Z',
      status: 'Transferred'
    },
    {
      receiptName: 'Rose',
      receiptId: '5dc234f190',
      amount: '90.00',
      account: 'Kbank',
      paid: '2020-01-11T14:00:00.549Z',
      status: 'Transferred'
    }
  ]
});
